// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__j5-ag","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1hBcZ","obliqueLine":"membershipbadge_obliqueLine__3EU5v"};